import * as React from "react";
import { styled } from "@mui/material";
const base = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 4h12M2 12h20M2 20h12", stroke: "#18A0FB", strokeWidth: 3, strokeLinecap: "round" }));
const SvgHamburgerMenu = styled(base)({});
export default SvgHamburgerMenu;
